const styles = {
  button: {
    fontSize: '1.5rem',
    color: 'white',
    backgroundColor: '#333333',
    border: 'none',
    padding: '10px 20px',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
  container: { margin: '20px' },
}

export default function StyledButton({ link, text }) {
  return (
    <div style={styles.container}>
      <a href={link} style={styles.button}>
        {text}
      </a>
    </div>
  )
}
